export interface IPhotoFeatureIcon {
  type: EPhotoFeatureIcon;
}

export enum EPhotoFeatureIcon {
  Has3dTour = 'has3dTour',
  HasFlatTourBooking = 'hasFlatTourBooking',
}
